<div *ngIf="product$ | async as product" class="section pdp-tab">
  <div class="d-none d-md-block">
    <ul ngbNav #nav="ngbNav" class="nav-tabs w-100" [(activeId)]="active" tabindex="-1">
      <li [ngbNavItem]="'DESCRIPTION'" data-testing-id="product-description-tab" role="presentation">
        <a ngbNavLink>{{ 'product.description.heading' | translate }}</a>
        <ng-template ngbNavContent>
          <div [ishServerHtml]="product.longDescription"></div>
        </ng-template>
      </li>

      <ng-container *ngIf="product.attributeGroups?.PDPTabs">
        <li
          *ngFor="let tab of generateProductTabs(product.attributeGroups['PDPTabs']) | keyvalue : originalOrder"
          [ngbNavItem]="tab.key"
          data-testing-id="product-description-tab"
          role="presentation"
        >
          <a ngbNavLink>{{ tab.key }}</a>
          <ng-template ngbNavContent>
            <div [ishServerHtml]="tab.value"></div>
          </ng-template>
        </li>
      </ng-container>

      <li *ngIf="product.attributes?.length" [ngbNavItem]="'DETAILS'" role="presentation">
        <a ngbNavLink>{{ 'product.details.heading' | translate }}</a>
        <ng-template ngbNavContent>
          <ish-product-attributes [product]="product"></ish-product-attributes>
        </ng-template>
      </li>

      <li *ngIf="product.attachments?.length" [ngbNavItem]="'ATTACHMENTS'" role="presentation">
        <a ngbNavLink>{{ 'product.attachments.heading' | translate }}</a>
        <ng-template ngbNavContent>
          <ish-product-attachments></ish-product-attachments>
        </ng-template>
      </li>
      <ng-container *ngIf="(isVariationMaster$ | async) === false">
        <li *ishFeature="'rating'" [ngbNavItem]="'REVIEWS'" role="presentation">
          <a ngbNavLink>{{ 'product.reviews.heading' | translate }} ({{ product.numberOfReviews }})</a>
          <ng-template ngbNavContent>
            <ish-lazy-product-reviews></ish-lazy-product-reviews>
          </ng-template>
        </li>
      </ng-container>
    </ul>

    <div [ngbNavOutlet]="nav"></div>
  </div>

  <!-- Mobile Accordion View -->
  <div class="product-accordion d-block d-md-none">
    <ish-accordion>
      <ish-accordion-item [isCollapsed]="true" heading="{{ 'product.description.heading' | translate }}">
        <div class="p-4">
          <div>
            <div [ishServerHtml]="product.longDescription"></div>
          </div>
        </div>
      </ish-accordion-item>
      <div *ngIf="product.attributeGroups?.PDPTabs">
        <ish-accordion-item
          *ngFor="let tab of generateProductTabs(product.attributeGroups['PDPTabs']) | keyvalue : originalOrder"
          data-testing-id="product-description-tab"
          heading="{{ tab.key }}"
        >
          <div>
            <div [ishServerHtml]="tab.value"></div>
          </div>
        </ish-accordion-item>
      </div>
      <div *ngIf="product.attributes?.length">
        <ish-accordion-item heading="{{ 'product.details.heading' | translate }}">
          <div class="p-4">
            <ish-product-attributes [product]="product"></ish-product-attributes>
          </div>
        </ish-accordion-item>
      </div>
      <div *ngIf="product.attachments?.length">
        <ish-accordion-item heading="{{ 'product.attachments.heading' | translate }}">
          <div class="p-4">
            <ish-product-attachments></ish-product-attachments>
          </div>
        </ish-accordion-item>
      </div>
      <div *ishFeature="'rating'">
        <ish-accordion-item heading="{{ 'product.reviews.heading' | translate }} ({{ product.numberOfReviews }})">
          <div class="p-4">
            <ish-lazy-product-reviews></ish-lazy-product-reviews>
          </div>
        </ish-accordion-item>
      </div>
    </ish-accordion>
  </div>
</div>
